export const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000)?.toFixed() + "M";
  } else if (num >= 1000) {
    return (num / 1000)?.toFixed() + "k";
  } else {
    return Number(num).toFixed();
  }
};
